import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'na' })
export class NaPipe implements PipeTransform {
  transform(value?: string | null): string {
    return value || 'N/A';
  }
}
